var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhiteSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.55 9.9c6.63 4.64 11.736 9.53 15.32 14.668 16.78 6.254 28.73 22.423 28.73 41.382 0 24.383-19.767 44.15-44.15 44.15S16.3 90.333 16.3 65.95c0-18.99 11.989-35.179 28.81-41.412C48.726 19.41 53.873 14.53 60.55 9.9zm21.643 33.189.004.2.003.461c0 12.463-7.217 23.747-21.65 33.85C45.983 67.497 38.7 56.213 38.7 43.75c0-.22.002-.44.007-.66-6.041 5.746-9.807 13.863-9.807 22.86 0 17.425 14.125 31.55 31.55 31.55S92 83.375 92 65.95c0-8.997-3.766-17.114-9.807-22.861z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.874 33.151c-4.995-6.615-9.083-13.145-6.854-11.762 3.482 2.162 28.662 5.305 36.112 33.652 7.45 28.347-14.192 42.362-20.932 43.65-.739.142-1.934.516-3.547.754-.591.088-1.604.173-3.04.255l.025-.061c-4.071.12-9.388-1.387-12.538-3.606-8.322-5.864-11.448-13.846-9.38-23.945h13.586c-2.605 5.35-1.94 10.034 1.995 14.054 2.137 2.183 5.627 3.5 9.8 2.763 2.184-.386 4.307-1.628 6.371-3.726l-.005.029C89.835 79.38 91.486 73.692 92 68.104c.812-8.829-3.077-18.485-9.8-25.102-2.151-2.117-4.837-5.314-7.38-8.611l-.475-.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.55 77.6C74.983 67.497 82.2 56.213 82.2 43.75c0-12.463-7.217-23.747-21.65-33.85C45.983 20.003 38.7 31.287 38.7 43.75c0 12.463 7.283 23.747 21.85 33.85z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhiteSmall);
export default __webpack_public_path__ + "static/media/logo-white-small.b2d0df038cd3fb5103f8bfbfedd469d9.svg";
export { ForwardRef as ReactComponent };